import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string;

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    flowType: "pkce",
    detectSessionInUrl: false,
  },
});

const basePath = __BASE_PATH__.split("/").filter(Boolean).join("/");
export const pathPrefix = basePath ? `/${basePath}` : "";

export const authCallbackUrl = `${window.location.origin}${pathPrefix}/auth/callback`;

export const DEFAULT_DESTINATION = "/provider/settlements";

export function resolveNextDestination(next: string | null | undefined): string {
  if (!next || !next.startsWith("/") || next.startsWith("//")) {
    return DEFAULT_DESTINATION;
  }
  if (next === "/auth/reset-password") {
    return next;
  }
  if (next.startsWith("/auth")) {
    return DEFAULT_DESTINATION;
  }
  return next;
}